import React, { useEffect } from "react"
import {
  change,
  Field,
  FormSection,
  formValueSelector,
  initialize,
  reduxForm,
} from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { SaveButton } from "components/Buttons"
import {
  AsyncTypeahedSelect,
  CheckboxField,
  RadioField,
} from "components/RenderInput"
import { connect } from "react-redux"
import {
  getMetaTags,
  getPrivateMessage,
  getUsersBySearch,
  resetPrivateMessage,
  updatePrivateMessage,
} from "store/actions"
import PropTypes from "prop-types"
import PhoneArea from "components/PhonePreview/PhoneArea"
import { mapApiToPMForm, mapPMFormToApi } from "../utils"
import { LoadingIndicator } from "components/LoadingIndicator"

let PrivateMessage = props => {
  useEffect(() => {
    props.getPrivateMessage({
      id: props.selectedEvent.id,
      values: { menu_item_id: props?.feature?.id, dashboard: true },
    })
    props?.getMetaTags({ hide_for_business_unit: 1 })
    return () => {
      props.resetPrivateMessage()
    }
  }, [])

  useEffect(() => {
    if (props.privateMessage) {
      props.initializeForm(mapApiToPMForm(props.privateMessage))
    }
  }, [props.privateMessage])

  const submitHandler = data => {
    const updatedData = {
      ...props?.privateMessage,
      ...mapPMFormToApi(data),
      group_chat_only: data?.private_message_form?.group_chat_only, // Include group_chat_only based on groupChatPermission
    }
    props.updatePrivateMessage(updatedData)
  }

  return (
    <FormSection name={props.form}>
      {props?.loading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm">
            <Row className="mb-3">
              <Col xl={12}>
                <h3>{props.feature.label}</h3>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    <h4>SELECT LAYOUT </h4>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col xs={12} className="my-1">
                        <Field
                          name="layout"
                          value="1"
                          type="radio"
                          label="Classic Chat"
                          component={RadioField}
                        />
                      </Col>
                      <Col xs={12} className="my-1">
                        <Field
                          name="layout"
                          value="2"
                          type="radio"
                          label="Bulletin Style Chat"
                          component={RadioField}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card>
                  <CardHeader>
                    <h4>WHICH USER(S) CAN A PRIVATE MESSAGE BE SENT TO?</h4>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col xs={12} className="my-1">
                        <Field
                          name="group_chat_only"
                          component={CheckboxField}
                          label="Group Chat - App users will only be able to send a PM to the selected users group"
                          onChange={(event, newValue) => {
                            // Update group_chat_only based on groupChatPermission checkbox
                            props?.change(
                              "private_message_form.group_chat_only",
                              !newValue
                            )
                          }}
                        />
                        <br></br>

                        <Field
                          name="receivers"
                          value="all"
                          type="radio"
                          label="All Users"
                          component={RadioField}
                        />
                      </Col>
                      <Col xs={12} className="my-1">
                        <Field
                          name="receivers"
                          value="users"
                          type="radio"
                          label="Selected Users"
                          component={RadioField}
                        />
                      </Col>
                      <Col xs={12} className="my-1">
                        <Field
                          name="receivers"
                          value="tags"
                          type="radio"
                          label="Selected Tags"
                          component={RadioField}
                        />
                      </Col>
                      {props.receivers === "users" && (
                        <Col xs={12} className="my-2">
                          <Field
                            name="userSearch"
                            component={AsyncTypeahedSelect}
                            placeholder="Search for specific users"
                            options={props.usersBySearch.map(user => ({
                              ...user,
                              label: `${user.first_name} ${user.last_name} (${user.email})`,
                              value: user.id,
                            }))}
                            inlineValue={false}
                            onInputChange={text =>
                              props.getUsersBySearch({
                                t: text,
                                event_id: props.selectedEvent.id,
                                include_admins: true,
                              })
                            }
                            isMulti={true}
                            onMenuClose={() => {
                              props.getUsersBySearch({
                                event_id: props.selectedEvent.id,
                                include_admins: true,
                              })
                            }}
                          />
                        </Col>
                      )}
                      {props.receivers === "tags" && (
                        <Col xs={12} className="my-2">
                          <Field
                            name="tagSearch"
                            placeholder="Enter tag"
                            component={AsyncTypeahedSelect}
                            options={props?.metaTags.map(tag => ({
                              ...tag,
                              label: tag.tag,
                              value: tag.id,
                            }))}
                            isMulti={true}
                          />
                        </Col>
                      )}
                    </Row>
                  </CardBody>
                </Card>
                <Card>
                  <CardHeader>
                    <h4>SELECT A PRIVATE MESSAGE ADMIN(S)</h4>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col>
                        <Field
                          name="adminSetupEnabled"
                          component={CheckboxField}
                          label={"SELECT A PRIVATE MESSAGE ADMIN(S)"}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              props?.change(
                                "private_message_form.adminUsers",
                                "users"
                              )
                              props?.change(
                                "private_message_form.adminReceivers",
                                "all"
                              )
                            } else {
                              props?.change(
                                "private_message_form.adminUsers",
                                "none"
                              )
                            }
                          }}
                        />
                      </Col>
                    </Row>
                    {props?.formValues?.adminSetupEnabled && (
                      <>
                        <Row className="mt-2">
                          <Col xs={12} className="my-1">
                            <Field
                              name="adminUsers"
                              value="users"
                              type="radio"
                              label="Select user(s) to be PM Admin"
                              component={RadioField}
                            />
                          </Col>
                          <Col xs={12} className="my-1">
                            <Field
                              name="adminUsers"
                              value="tags"
                              type="radio"
                              label="Select tagged user(s) to be your PM Admin"
                              component={RadioField}
                            />
                          </Col>
                          {props.formValues?.adminUsers === "users" && (
                            <Col xs={12} className="my-2">
                              <Field
                                name="adminUserSearch"
                                component={AsyncTypeahedSelect}
                                placeholder="Search for specific users"
                                options={props.usersBySearch.map(user => ({
                                  ...user,
                                  label: `${user.first_name} ${user.last_name} (${user.email})`,
                                  value: user.id,
                                }))}
                                inlineValue={false}
                                onInputChange={text =>
                                  props.getUsersBySearch({
                                    t: text,
                                    event_id: props.selectedEvent.id,
                                    include_admins: true,
                                  })
                                }
                                isMulti={true}
                                onMenuClose={() => {
                                  props.getUsersBySearch({
                                    event_id: props.selectedEvent.id,
                                    include_admins: true,
                                  })
                                }}
                              />
                            </Col>
                          )}
                          {props.formValues?.adminUsers === "tags" && (
                            <Col xs={12} className="my-2">
                              <Field
                                name="adminTagSearch"
                                placeholder="Enter tag"
                                component={AsyncTypeahedSelect}
                                options={props?.metaTags.map(tag => ({
                                  ...tag,
                                  label: tag.tag,
                                  value: tag.id,
                                }))}
                                isMulti={true}
                              />
                            </Col>
                          )}
                        </Row>
                        <Row className="mt-3">
                          <Col xs={12}>
                            <h5>
                              To whom can a Private Message Admin send a private
                              message to?
                            </h5>
                          </Col>
                          <Col xs={12} className="my-1">
                            <Field
                              name="adminReceivers"
                              value="all"
                              type="radio"
                              label="All Users"
                              component={RadioField}
                            />
                          </Col>
                          <Col xs={12} className="my-1">
                            <Field
                              name="adminReceivers"
                              value="users"
                              type="radio"
                              label="Selected Users"
                              component={RadioField}
                            />
                          </Col>
                          <Col xs={12} className="my-1">
                            <Field
                              name="adminReceivers"
                              value="tags"
                              type="radio"
                              label="Selected Tags"
                              component={RadioField}
                            />
                          </Col>
                          {props.formValues?.adminReceivers === "users" && (
                            <Col xs={12} className="my-2">
                              <Field
                                name="adminReceiverUserSearch"
                                component={AsyncTypeahedSelect}
                                placeholder="Search for specific users"
                                options={props.usersBySearch.map(user => ({
                                  ...user,
                                  label: `${user.first_name} ${user.last_name} (${user.email})`,
                                  value: user.id,
                                }))}
                                inlineValue={false}
                                onInputChange={text =>
                                  props.getUsersBySearch({
                                    t: text,
                                    event_id: props.selectedEvent.id,
                                    include_admins: true,
                                  })
                                }
                                isMulti={true}
                                onMenuClose={() => {
                                  props.getUsersBySearch({
                                    event_id: props.selectedEvent.id,
                                    include_admins: true,
                                  })
                                }}
                              />
                            </Col>
                          )}
                          {props.formValues?.adminReceivers === "tags" && (
                            <Col xs={12} className="my-2">
                              <Field
                                name="adminReceiverTagSearch"
                                placeholder="Enter tag"
                                component={AsyncTypeahedSelect}
                                options={props?.metaTags.map(tag => ({
                                  ...tag,
                                  label: tag.tag,
                                  value: tag.id,
                                }))}
                                isMulti={true}
                              />
                            </Col>
                          )}
                        </Row>
                      </>
                    )}
                  </CardBody>
                </Card>

                <Card>
                  <CardHeader>
                    <h4>MEDIA UPLOAD</h4>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col>
                        <Field
                          name="mediaUploadEnabled"
                          component={CheckboxField}
                          label={
                            "Upload Media from Local Devices (photos & videos)"
                          }
                          onChange={(event, newValue) => {
                            if (newValue) {
                              props?.change(
                                "private_message_form.mediaUsers",
                                "all"
                              )
                            } else {
                              props?.change(
                                "private_message_form.mediaUsers",
                                "none"
                              )
                            }
                          }}
                        />
                      </Col>
                    </Row>
                    {props?.formValues?.mediaUploadEnabled && (
                      <>
                        <Row>
                          <Col xs={12} className="my-1">
                            <Field
                              name="mediaUsers"
                              value="all"
                              type="radio"
                              label="All Users"
                              component={RadioField}
                            />
                          </Col>
                          <Col xs={12} className="my-1">
                            <Field
                              name="mediaUsers"
                              value="users"
                              type="radio"
                              label="Selected Users"
                              component={RadioField}
                            />
                          </Col>
                          <Col xs={12} className="my-1">
                            <Field
                              name="mediaUsers"
                              value="tags"
                              type="radio"
                              label="Selected Tags"
                              component={RadioField}
                            />
                          </Col>
                          {props.formValues?.mediaUsers === "users" && (
                            <Col xs={12} className="my-2">
                              <Field
                                name="mediaUserSearch"
                                component={AsyncTypeahedSelect}
                                placeholder="Search for specific users"
                                options={props.usersBySearch.map(user => ({
                                  ...user,
                                  label: `${user.first_name} ${user.last_name} (${user.email})`,
                                  value: user.id,
                                }))}
                                inlineValue={false}
                                onInputChange={text =>
                                  props.getUsersBySearch({
                                    t: text,
                                    event_id: props.selectedEvent.id,
                                    include_admins: true,
                                  })
                                }
                                isMulti={true}
                                onMenuClose={() => {
                                  props.getUsersBySearch({
                                    event_id: props.selectedEvent.id,
                                    include_admins: true,
                                  })
                                }}
                              />
                            </Col>
                          )}
                          {props.formValues?.mediaUsers === "tags" && (
                            <Col xs={12} className="my-2">
                              <Field
                                name="mediaTagSearch"
                                placeholder="Enter tag"
                                component={AsyncTypeahedSelect}
                                options={props?.metaTags.map(tag => ({
                                  ...tag,
                                  label: tag.tag,
                                  value: tag.id,
                                }))}
                                isMulti={true}
                              />
                            </Col>
                          )}
                        </Row>
                      </>
                    )}
                  </CardBody>
                </Card>
                <Row>
                  <Col className="d-flex justify-content-center">
                    <SaveButton
                      type="button"
                      content="Save"
                      onClick={props.handleSubmit(submitHandler)}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xl={4} className="mt-4 custom-features-preview">
                <PhoneArea>
                  <div
                    style={{
                      backgroundColor: "gray",
                      backgroundImage: `url(${
                        props.formValues?.layout === "1"
                          ? "https://admin.dev.markedprivate.com/app/images/preview/pm_template1.jpg"
                          : "	https://admin.dev.markedprivate.com/app/images/preview/pm_template2.png"
                      })`,
                      width: "105%",
                      height: "102%",
                      backgroundSize: "100% 100%",
                      marginLeft: "-10px",
                      backgroundPosition: "center center",
                    }}
                  />
                </PhoneArea>
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </FormSection>
  )
}

PrivateMessage = reduxForm({
  form: FORM_NAMES.PRIVATE_MESSAGE,
  initialValues: { private_message_form: { layout: "1", receivers: "all" } },
})(PrivateMessage)

const selector = formValueSelector(FORM_NAMES.PRIVATE_MESSAGE)

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  selectedEvent: state.experiences.selectedEvent,
  receivers: selector(state, "private_message_form.receivers"),
  privateMessage: state.PrivateMessage.privateMessage,
  loading: state.PrivateMessage.loading,
  formValues: selector(state, "private_message_form"),
  metaTags: state.Tags.metaTags,
  usersBySearch: state.SiteUsers.usersBySearch,
})

const mapDispatchToProps = dispatch => ({
  getUsersBySearch: values => dispatch(getUsersBySearch(values)),
  getPrivateMessage: values => dispatch(getPrivateMessage(values)),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.PRIVATE_MESSAGE, values)),
  updatePrivateMessage: values => dispatch(updatePrivateMessage(values)),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.PRIVATE_MESSAGE, field, value)),
  resetPrivateMessage: () => dispatch(resetPrivateMessage()),
  getMetaTags: values => dispatch(getMetaTags(values)),
})

PrivateMessage.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateMessage)
